var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStage2Top(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_44147",
    "data-name": "Group 44147",
    xmlns: "http://www.w3.org/2000/svg",
    width: 190.448,
    height: 211.831,
    viewBox: "0 0 190.448 211.831",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9515",
    "data-name": "Path 9515",
    d: "M184.79,210.223c-.447,1.577-.836,6.042-1.457,11.831-.552,5.2-5.873,24.545-6.431,26.5-3.507,12.373-11.115,22.731-18.987,23.941-8.923,1.372-24.24,5.027-29.809,10.842-.115.12-.226.247-.336.378-4.859,5.831-7.025,15.564-17.584,16.721-10.564-1.151-12.73-10.884-17.589-16.721-.11-.132-.226-.263-.352-.389-5.573-5.8-20.875-9.459-29.793-10.831-7.877-1.209-15.485-11.058-18.992-23.436a52.183,52.183,0,0,1-1.341-6.01c-.557-3.439-4.533-15.8-5.084-21-.621-5.789-1.015-10.254-1.462-11.831-.752-2.655,36.434.326,74.613,4.065,38.174-3.738,75.355-6.72,74.6-4.065",
    transform: "translate(-15.062 -88.606)",
    fill: "#d3b1a7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9516",
    "data-name": "Path 9516",
    d: "M182.7,227.085l-5,17.089s-2.629,9.2-4.469,13.935-15.512,13.408-19.192,18.929-13.214,9.055-22.379,13.861c-.379.2-.778.384-1.2.557-4.122,1.688-10.443,2.319-16.432,2.482-5.989-.162-12.309-.794-16.432-2.482-.426-.174-.826-.357-1.2-.557-9.165-4.806-18.7-8.339-22.379-13.861s-17.352-14.2-19.192-18.929-4.469-13.935-4.469-13.935l-5-17.089,68.672,5.674Z",
    transform: "translate(-19.209 -96.177)",
    fill: "#efcabf"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9517",
    "data-name": "Path 9517",
    d: "M186.347,81.983C178.694,34.022,152.461.043,103.893.043h-.007C103.045.017,102.2,0,101.351,0,52.783,0,26.55,33.98,18.9,81.941c-5.5,34.485,7.423,58.356,29.27,74.089,4.091,2.945,10.423,5,16.65,6.744,9.993,6.319,17.677,11.521,35.361,12.159.19.007.383.013.577.016,1.025.031,2.072.051,3.166.051a25.726,25.726,0,0,0,3.3-.21c16.04-.96,23.506-5.92,32.971-11.909,6.3-1.762,12.743-3.828,16.885-6.81,21.848-15.733,34.773-39.6,29.27-74.089",
    transform: "translate(-7.467 -0.001)",
    fill: "#060606"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9518",
    "data-name": "Path 9518",
    d: "M300.051,197.812s11.42-6.172,11.42,0-10.516,18.6-13.671,23.429-12.048,7.432-12.048,7.432Z",
    transform: "translate(-121.024 -82.618)",
    fill: "#e5bfb1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9519",
    "data-name": "Path 9519",
    d: "M11.42,190.515S0,184.342,0,190.515s10.517,18.6,13.672,23.43,12.048,7.432,12.048,7.432Z",
    transform: "translate(0 -79.527)",
    fill: "#e5bfb1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9520",
    "data-name": "Path 9520",
    d: "M54.008,246.294s-.95-4.809,10.872-12.858,1.616,22.2,25.437,33.674-18.163-2.6-18.163-2.6Z",
    transform: "translate(-22.867 -98.298)",
    fill: "#efcabf"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9521",
    "data-name": "Path 9521",
    d: "M239.028,251.1s.949-4.809-10.872-12.858-1.616,22.2-25.437,33.674,18.163-2.6,18.163-2.6Z",
    transform: "translate(-82.76 -100.334)",
    fill: "#efcabf"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11604",
    "data-name": "Path 11604",
    d: "M-13213.97-1418.722s10.9-31.128,31.249-24.977,14.853,24.945,20.177,32.5,29.53,7.241,33.312-2.222,5.646-30.755,21.262-30.282,26.613,18.466,26.613,21.305-14.951,19.693-20.158,26.317-70.722,24.312-85.389,7.279S-13213.97-1418.722-13213.97-1418.722Z",
    transform: "translate(13243.657 1565.244)",
    fill: "#efcabf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage2Top);
export default __webpack_public_path__ + "static/media/stage2_top.b6e5a98f61b622e23a01eb7492f9c2f5.svg";
export { ForwardRef as ReactComponent };